/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateQuestionConfigDto } from '../models';
// @ts-ignore
import type { FormQuestionConfigDto } from '../models';
// @ts-ignore
import type { FormQuestionDto } from '../models';
// @ts-ignore
import type { QuestionConfigDetailDto } from '../models';
// @ts-ignore
import type { QuestionsConfigControllerGetQuestionConfigs200Response } from '../models';
// @ts-ignore
import type { UpdateQuestionConfigDto } from '../models';
/**
 * QuestionsConfigApi - axios parameter creator
 * @export
 */
export const QuestionsConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateQuestionConfigDto} createQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsConfigControllerCreateQuestionConfig: async (createQuestionConfigDto: CreateQuestionConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createQuestionConfigDto' is not null or undefined
            assertParamExists('questionsConfigControllerCreateQuestionConfig', 'createQuestionConfigDto', createQuestionConfigDto)
            const localVarPath = `/api/questions-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsConfigControllerGetQuestionConfigDetail: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionsConfigControllerGetQuestionConfigDetail', 'questionId', questionId)
            const localVarPath = `/api/questions-config/{questionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsConfigControllerGetQuestionConfigs: async (code?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questions-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateQuestionConfigDto} updateQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsConfigControllerUpdateQuestionConfig: async (questionId: string, updateQuestionConfigDto: UpdateQuestionConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionsConfigControllerUpdateQuestionConfig', 'questionId', questionId)
            // verify required parameter 'updateQuestionConfigDto' is not null or undefined
            assertParamExists('questionsConfigControllerUpdateQuestionConfig', 'updateQuestionConfigDto', updateQuestionConfigDto)
            const localVarPath = `/api/questions-config/{questionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionsConfigApi - functional programming interface
 * @export
 */
export const QuestionsConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionsConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateQuestionConfigDto} createQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionsConfigControllerCreateQuestionConfig(createQuestionConfigDto: CreateQuestionConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormQuestionConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionsConfigControllerCreateQuestionConfig(createQuestionConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsConfigApi.questionsConfigControllerCreateQuestionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionsConfigControllerGetQuestionConfigDetail(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionConfigDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionsConfigControllerGetQuestionConfigDetail(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsConfigApi.questionsConfigControllerGetQuestionConfigDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionsConfigControllerGetQuestionConfigs(code?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionsConfigControllerGetQuestionConfigs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionsConfigControllerGetQuestionConfigs(code, search, orderBy, orderDirection, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsConfigApi.questionsConfigControllerGetQuestionConfigs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateQuestionConfigDto} updateQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionsConfigControllerUpdateQuestionConfig(questionId: string, updateQuestionConfigDto: UpdateQuestionConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormQuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionsConfigControllerUpdateQuestionConfig(questionId, updateQuestionConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsConfigApi.questionsConfigControllerUpdateQuestionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionsConfigApi - factory interface
 * @export
 */
export const QuestionsConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionsConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateQuestionConfigDto} createQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsConfigControllerCreateQuestionConfig(createQuestionConfigDto: CreateQuestionConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<FormQuestionConfigDto> {
            return localVarFp.questionsConfigControllerCreateQuestionConfig(createQuestionConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsConfigControllerGetQuestionConfigDetail(questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionConfigDetailDto> {
            return localVarFp.questionsConfigControllerGetQuestionConfigDetail(questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsConfigControllerGetQuestionConfigs(code?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<QuestionsConfigControllerGetQuestionConfigs200Response> {
            return localVarFp.questionsConfigControllerGetQuestionConfigs(code, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateQuestionConfigDto} updateQuestionConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionsConfigControllerUpdateQuestionConfig(questionId: string, updateQuestionConfigDto: UpdateQuestionConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<FormQuestionDto> {
            return localVarFp.questionsConfigControllerUpdateQuestionConfig(questionId, updateQuestionConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionsConfigApi - object-oriented interface
 * @export
 * @class QuestionsConfigApi
 * @extends {BaseAPI}
 */
export class QuestionsConfigApi extends BaseAPI {
    /**
     * 
     * @param {CreateQuestionConfigDto} createQuestionConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsConfigApi
     */
    public questionsConfigControllerCreateQuestionConfig(createQuestionConfigDto: CreateQuestionConfigDto, options?: RawAxiosRequestConfig) {
        return QuestionsConfigApiFp(this.configuration).questionsConfigControllerCreateQuestionConfig(createQuestionConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsConfigApi
     */
    public questionsConfigControllerGetQuestionConfigDetail(questionId: string, options?: RawAxiosRequestConfig) {
        return QuestionsConfigApiFp(this.configuration).questionsConfigControllerGetQuestionConfigDetail(questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [code] 
     * @param {string | null} [search] 
     * @param {string | null} [orderBy] 
     * @param {string | null} [orderDirection] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsConfigApi
     */
    public questionsConfigControllerGetQuestionConfigs(code?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return QuestionsConfigApiFp(this.configuration).questionsConfigControllerGetQuestionConfigs(code, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} questionId 
     * @param {UpdateQuestionConfigDto} updateQuestionConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsConfigApi
     */
    public questionsConfigControllerUpdateQuestionConfig(questionId: string, updateQuestionConfigDto: UpdateQuestionConfigDto, options?: RawAxiosRequestConfig) {
        return QuestionsConfigApiFp(this.configuration).questionsConfigControllerUpdateQuestionConfig(questionId, updateQuestionConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}

